import { useToast } from "vue-toastification";
import useLoadingStore from "@shared-stores/loading.store";

export default function (error: any, options?: object)
{
	const toast = useToast();
	try
	{
		if (typeof error === "string")
		{
			toast.error(error, options);
		}
		else
		{
			if (error?.code == 400)
			{
				toast.error(error?.message || "Requête invalide.", options);
			}
			else if (error?.code == 401)
			{
				toast.error(error?.message);
			}
			else if (error?.code == 402)	// Payment Required
			{
				toast.error(error?.message);
			}
			else if (error?.code == 403)
			{
				toast.error(error?.message);
			}
			else if (error?.code == 404)
			{
				toast.error(error?.message);
			}
			else if (error?.code == 409)	// Conflict
			{
				toast.error(error?.message);
			}
			else if (error?.code == 415)
			{
				toast.error(error?.message);
			}
			else if (error?.code == 429)
			{
				toast.error(error?.message);
			}
			else if (error?.code == 422)
			{
				toast.error("Le formulaire a renvoyé des erreurs.", options);
			}
			else if (error.code == 500)
			{
				const errMessage = error?.message || "Notre serveur rencontre actuellement des problèmes.";
				toast.error(errMessage, options);
			}
			// Sans `code` numérique, ce n'est pas une erreur de notre API — Stripe.js, par exemple.
			// Sans cette branche, l'échec de paiement se produisait sans que rien ne s'affiche.
			else if (typeof error?.message === "string" && error.message)
			{
				toast.error(error.message, options);
			}
			else if (error)
			{
				toast.error("Une erreur est survenue.", options);
			}
		}
	}
	catch (e)
	{
		toast.error(error as string, options);
	}
	finally
	{
		const loadingStore = useLoadingStore();
		loadingStore.resetStack();
	}
}
